import React, { useEffect, useState } from 'react'
import { useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom'
// import { useSelector } from "react-redux";
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import 'react-overlay-loader/styles.css';

// Header
const Header = (props) => {

  let navigate = useNavigate();
  let [pathname, setPathname] = useState('');

  let user_info = useSelector(state => {
    if (state.user && state.user.user_info) {
      return state.user.user_info
    } else {
      return ''
    }
  });

  useEffect(() => {
    setPathname(window.location.pathname)
  }, [window.location.pathname]);

  return (
    <div className="shadow2dp" style={{
      backgroundColor: '#008CC8',
      paddingTop: 40,
      paddingBottom: 20,
    }}>
      <Container>

        <Row style={{
          fontSize: 18,
        }}>

          <Col md="4" xs="12" style={{
            textAlign: 'left',
          }}>

            {/*<img src={require("../../../images/shabelab_log3.svg")}
              style={{
                marginRight: 20,
                width: 40,
                // height: 38,
            }} alt="shabelab log" />*/}

          </Col>

          <Col md="8" xs="12" style={{
            textAlign: 'right',
          }}>


            <Link to="/docs_top" style={{
              marginLeft: 8,
              marginRight: 8,
              textDecoration: 'none',
              color: pathname.indexOf("docs_") !== -1 ? 'yellow' : 'white',
              fontWeight: 'bold',
            }}>ドキュメント</Link>

            <span style={{
              color: '#ffffff',
            }}>
              |
            </span>

            {/*<Link to="/narancia_top" style={{
              marginLeft: 8,
              marginRight: 8,
              textDecoration: 'none',
              color: pathname.indexOf("narancia_") !== -1 ? 'yellow' : 'white',
              fontWeight: 'bold',
            }}>エンジン評価</Link>

            <span style={{
              color: '#ffffff',
            }}>
              |
            </span>*/}

            {/*<Link to="/evaluation_top" style={{
              marginLeft: 8,
              marginRight: 8,
              textDecoration: 'none',
              color: pathname.indexOf("evaluation_") !== -1 ? 'yellow' : 'white',
              fontWeight: 'bold',
            }}>エンジン比較</Link>

            <span style={{
              color: '#ffffff',
            }}>
              |
            </span>*/}

            <Link to="/api_manager_top" style={{
              marginLeft: 8,
              marginRight: 8,
              textDecoration: 'none',
              color: pathname.indexOf("api_") !== -1 ? 'yellow' : 'white',
              fontWeight: 'bold',
            }}>API管理</Link>


            <span style={{
              color: '#ffffff',
            }}>
              |
            </span>

            <Link to="/account" style={{
              marginLeft: 8,
              marginRight: 8,
              textDecoration: 'none',
              color: pathname === '/account' ? 'yellow' : 'white',
              fontWeight: 'bold',
            }}>アカウント</Link>

          </Col>
        </Row>

      </Container>
    </div>
  )
}

export default Header
